import 'swiper/swiper.min.css';

import { ControlButton, Controls, SliderPagination } from './styles';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import styled, { createGlobalStyle } from 'styled-components';

import IconSVG from '../Icon/IconSVG';
import PropTypes from 'prop-types';
import React from 'react';

const SliderControls = ({ isEnd, isBeginning, currentIndex }) => {
  const swiper = useSwiper();

  const handleLeft = () => {
    swiper.slidePrev();
  };

  const handleRight = () => {
    swiper.slideNext();
  };

  return (
    <Controls>
      <ControlButton disabled={isBeginning} onClick={handleLeft}>
        <IconSVG name="arrowLeft" />
      </ControlButton>
      {(!isEnd || !isBeginning) && (
        <SliderPagination className="swiper-slider-pagination" />
      )}
      <ControlButton disabled={isEnd} onClick={handleRight}>
        <IconSVG name="arrowRight" />
      </ControlButton>
    </Controls>
  );
};

SliderControls.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  isEnd: PropTypes.bool,
  isBeginning: PropTypes.bool,
  currentIndex: PropTypes.number
};

export default SliderControls;
